import clsx from "clsx";
import type { FC } from "react";

import { Link } from "utils/routing/components/Link";

interface DisplayCaptionProps {
  caption: string;
  bgColorClass?: string;
  linkText?: string;
  linkUrl?: string;
}

export const DisplayCaption: FC<DisplayCaptionProps> = ({
  caption,
  bgColorClass = "bg-green-shade-20",
  linkText,
  linkUrl,
}) => {
  return (
    <div className="relative z-10 flex w-full justify-center">
      <div
        className={clsx(
          "absolute rounded-b px-[7px] py-1 text-xs font-medium tracking-wide text-white",
          bgColorClass,
        )}
      >
        {caption}
        {linkText && linkUrl && (
          <>
            {" - "}
            <Link className="underline" to={linkUrl}>
              {linkText}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};
